<template>
    <v-form-element v-bind="$props">
        <input
            ref="input"
            :id="id"
            :type="type"
            :class="className"
            :placeholder="getPlaceholder()"
            v-model="model"
            :required="required"
            :disabled="disabled"
            @change="$emit('changed', $event)"
            @click="$emit('click')"
            @hover="$emit('hover')"
            @blur="$emit('blur')"
            @focus="$emit('focus')"
        />
    </v-form-element>
</template>

<script>

    import FormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            'v-form-element': FormElement
        },
        mixins: [mixin]
    }
</script>
